export class MoleculePanelEditRowTableDatabaseAccessesComponent {
    public templateUrl = require('./database-accesses.html?external');
}
